import { useTexts } from './hooks/useTexts';
import { StudentsRemovalRequestsResolvedFilters } from './StudentsRemovalRequestsResolvedFilters';
import { StudentsRemovalRequestsResolvedFiltersLoader } from './StudentsRemovalRequestsResolvedFiltersLoader';
import {
  StudentsRemovalRequestsResolvedListConsumer,
  StudentsRemovalRequestsResolvedListLoader,
} from './StudentsRemovalRequestsResolvedListLoader';
import { StudentsRemovalRequestsResolvedTable } from './StudentsRemovalRequestsResolvedTable';
import { StudentsRemovalRequestsResolvedTablePagination } from './StudentsRemovalRequestsResolvedTablePagination';

export function StudentsRemovalRequestsResolved() {
  const texts = useTexts();
  return (
    <>
      <StudentsRemovalRequestsResolvedListLoader>
        <p className="fs-18">{texts.description}</p>
        <StudentsRemovalRequestsResolvedFiltersLoader>
          {({ data }) => (
            <>
              <StudentsRemovalRequestsResolvedFilters data={data} />
              <StudentsRemovalRequestsResolvedListConsumer>
                {({ data, loading }) => {
                  return (
                    <>
                      <StudentsRemovalRequestsResolvedTable
                        data={data?.data ?? []}
                        loading={loading}
                      />
                      {!!data && !loading && data.total_pages > 1 && (
                        <StudentsRemovalRequestsResolvedTablePagination
                          total={data.total}
                          totalPages={data.total_pages}
                        />
                      )}
                    </>
                  );
                }}
              </StudentsRemovalRequestsResolvedListConsumer>
            </>
          )}
        </StudentsRemovalRequestsResolvedFiltersLoader>
      </StudentsRemovalRequestsResolvedListLoader>
    </>
  );
}
